import Vue from 'vue';
import App from './App.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading, {
	color: '#0856ab',
	blur: '0',
	opacity: 0.3
});
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
import { store } from './stores';
Vue.config.productionTip = false
import { i18n } from './plugins/i18n';
import PluginCore from './shared/core';
Vue.use(PluginCore);
import directive from './plugins/directive';
Vue.use(directive);
store.dispatch('verifyToken').then(() => {
	i18n.locale = store.state.auth.Language;
	new Vue({
		store,
		i18n,
		router,
		render: h => h(App)
	}).$mount('#app');
});